<div class="modal-box create-task-external-modal" cdkDrag>
    <form class="create-task-external-modal__form" [formGroup]="addTaskForm" (ngSubmit)="onSubmit()">
        <input type="hidden" formControlName="campaignId">
        <input type="hidden" formControlName="clientId">
        <input type="hidden" formControlName="dueDate">
        <input type="hidden" formControlName="assignedUserId">
        <div class="modal-header create-task-external-modal__header" cdkDragHandle>
            <div class="create-task-external-modal__headline">
                <span class="create-task-external-modal__eyebrow">{{ 'FORMS' | translate }}</span>
                <h4 class="modal-title create-task-external-modal__title">{{ 'URGENT_REQUEST_FORM.TITLE' | translate }}</h4>
            </div>
            <button type="button" class="create-task-external-modal__close" [attr.aria-label]="'CLOSE' | translate" (click)="close()">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body create-task-external-modal__body">
            <section class="create-task-external-modal__panel">
                <p class="create-task-external-modal__intro">{{ 'URGENT_REQUEST_FORM.DESCRIPTION' | translate }}</p>
                <div class="create-task-external-modal__stack">
                    <div class="create-task-external-modal__field">
                        <label class="create-task-external-modal__label" for="title">{{ 'SUBJECT' | translate }}</label>
                        <input id="title" type="text" class="form-control create-task-external-modal__control" formControlName="title"
                            [ngClass]="{ 'is-invalid': submitted && f.title.errors }" [placeholder]="'URGENT_REQUEST_FORM.SUBJECT_PLACEHOLDER' | translate">
                        <div *ngIf="submitted && f.title.errors" class="create-task-external-modal__feedback">
                            <div *ngIf="f.title.errors.required">{{ 'THIS_FIELD_IS_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                    <div class="create-task-external-modal__field">
                        <label class="create-task-external-modal__label" for="description">{{ 'REQUEST' | translate }}</label>
                        <textarea id="description" class="form-control create-task-external-modal__control create-task-external-modal__control--textarea" rows="3" formControlName="description"
                            [ngClass]="{ 'is-invalid': submitted && f.description.errors }"
                            [placeholder]="'URGENT_REQUEST_FORM.REQUEST_PLACEHOLDER' | translate"></textarea>
                        <div *ngIf="submitted && f.description.errors" class="create-task-external-modal__feedback">
                            <div *ngIf="f.description.errors.required">{{ 'THIS_FIELD_IS_REQUIRED' | translate }}</div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
        <div class="modal-footer create-task-external-modal__footer" cdkDragHandle>
            <div class="create-task-external-modal__actions">
                <button class="red-outline-button create-task-external-modal__button" type="button" (click)="close()">{{ 'CANCEL' | translate }}</button>
                <button class="blue-button create-task-external-modal__button" id="submit-change-tech" type="submit" [disabled]="addTaskForm.invalid || addTaskForm.disabled">{{ 'SUBMIT' | translate }}</button>
            </div>
        </div>
    </form>
</div>
